export const PUSH_PROMPT_STORAGE_PREFIX = "award-party:push-prompt";

export type PushPromptDecision = "accepted" | "dismissed";

export type PushPromptPermission =
  | "granted"
  | "denied"
  | "default"
  | "unsupported";

export function pushPromptStorageKey(userId: string): string {
  return `${PUSH_PROMPT_STORAGE_PREFIX}:${userId}`;
}

export function parsePushPromptDecision(
  raw: string | null,
): PushPromptDecision | null {
  if (raw === "accepted" || raw === "dismissed") {
    return raw;
  }
  return null;
}

export function shouldOfferPushPrompt(input: {
  decision: PushPromptDecision | null;
  permission: PushPromptPermission;
  nativeShell: boolean;
  nativeTokenPresent: boolean;
}): boolean {
  if (input.decision || input.nativeTokenPresent) {
    return false;
  }
  if (input.permission === "granted" || input.permission === "denied") {
    return false;
  }
  if (input.nativeShell) {
    return true;
  }
  return input.permission === "default";
}

export function shouldOfferNotificationSettings(input: {
  nativeShell: boolean;
  permission: "granted" | "denied" | "undetermined" | null;
  deviceEnabled: boolean;
}): boolean {
  return (
    input.nativeShell &&
    input.permission === "denied" &&
    !input.deviceEnabled
  );
}
